import BaseUseCase from "../../../base_use_case.js";

class DeleteCountryUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "delete",
      url: `/api/v1/admin/addresses/countries/${identifier}`,
    });
  }
}

const instance = new DeleteCountryUseCase();
export default instance;